/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListStatusesQueryVariables = Types.Exact<{
  input: Types.ListStatusesInput;
}>;


export type ListStatusesQuery = { __typename?: 'Query', listStatuses: Array<{ __typename?: 'StatusModel', internal: boolean, model: Types.StatusType, private_name: string, public_name: string, status_id: string, color?: string | null, sequence?: number | null }> };


export const ListStatusesDocument = gql`
    query listStatuses($input: ListStatusesInput!) {
  listStatuses(input: $input) {
    internal
    model
    private_name
    public_name
    status_id
    color
    sequence
  }
}
    `;
export function useListStatusesQuery(baseOptions: Apollo.QueryHookOptions<ListStatusesQuery, ListStatusesQueryVariables> & ({ variables: ListStatusesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListStatusesQuery, ListStatusesQueryVariables>(ListStatusesDocument, options);
      }
export function useListStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListStatusesQuery, ListStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListStatusesQuery, ListStatusesQueryVariables>(ListStatusesDocument, options);
        }
// @ts-ignore
export function useListStatusesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListStatusesQuery, ListStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<ListStatusesQuery, ListStatusesQueryVariables>;
export function useListStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListStatusesQuery, ListStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<ListStatusesQuery | undefined, ListStatusesQueryVariables>;
export function useListStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListStatusesQuery, ListStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListStatusesQuery, ListStatusesQueryVariables>(ListStatusesDocument, options);
        }
export type ListStatusesQueryHookResult = ReturnType<typeof useListStatusesQuery>;
export type ListStatusesLazyQueryHookResult = ReturnType<typeof useListStatusesLazyQuery>;
export type ListStatusesSuspenseQueryHookResult = ReturnType<typeof useListStatusesSuspenseQuery>;
export type ListStatusesQueryResult = Apollo.QueryResult<ListStatusesQuery, ListStatusesQueryVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListStatuses = withQueryResponseHandler(useListStatusesQuery);
